<template>
	<PayUnlockShell v-bind="shellProps" @select="$emit('select')">
		<template #left>
			<PayIcon icon="overseas" color="#fff" :bg="btnColor" :h5="h5" />
		</template>
		<template #info>
			<p class="g-block-pay-unlock__title">{{ data.title || 'Unlock Full Access' }}</p>
			<p class="g-block-pay-unlock__desc">{{ data.subtitle || 'Lifetime Access' }}</p>
			<div class="g-block-pay-unlock__prices">
				<span class="g-block-pay-unlock__price" :style="priceColor">{{ displayCurrencyPrice }}</span>
			</div>
		</template>
		<template #action>
			<PayUnlockButton
				:text="data.buttonText || 'Pay Now'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import PayIcon from '../shared/PayIcon.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatCurrencyPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_OVERSEAS } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockOverseas',
		components: { PayUnlockShell, PayUnlockButton, PayIcon },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_OVERSEAS;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_OVERSEAS);
			},
			priceColor() {
				return { color: this.btnColor };
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
				};
			},
			displayCurrencyPrice() {
				return formatCurrencyPrice(this.data);
			},
		},
	};
</script>
